import React from 'react';
import PropTypes from 'prop-types';

import { FlexBoxColumn } from '@ecp/common/src/layouts/flex/styled';
import { Spacing } from '@ecp/common/src/layouts/Spacing';
import Accordion from '@ecp/common/src/components/accordion/bo/Accordion';

const FormAccordion = ({ initialOpen, label, description, children, buttonless, customControl, noFold }) => {
  return (
    <Accordion initialOpen={initialOpen}>
      <FlexBoxColumn flex-grow={'1'}>
        <Accordion.Header height="48px">
          <Accordion.HeaderTitle>{label}</Accordion.HeaderTitle>
          <Spacing right={'14px'} />
          <Accordion.HeaderDescription>{description}</Accordion.HeaderDescription>
          <Accordion.Control buttonless={buttonless} noFold={noFold}>
            {customControl}
          </Accordion.Control>
        </Accordion.Header>
        <Accordion.Body>{children}</Accordion.Body>
      </FlexBoxColumn>
    </Accordion>
  );
};

FormAccordion.propTypes = {
  initialOpen: PropTypes.bool,
  label: PropTypes.any,
  description: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  buttonless: PropTypes.bool,
  noFold: PropTypes.bool,
  customControl: PropTypes.element,
};

FormAccordion.defaultProps = {
  label: '',
  children: <></>,
  buttonless: false,
  customControl: undefined,
  noFold: false,
};

export default FormAccordion;
